import { AccountState } from "./account.types";

export const state: AccountState = {
  accountData: null,
  loading: false,
  loadingAvailability: false,
  availability: null
};
